/**
 * One sentence for why a request to mytender failed, so the Tender tab can
 * tell "offline" from "this server has no Word sync yet" from "no access".
 */
import { isAxiosError } from "axios";

export const describeRequestError = (error: unknown): string => {
  if (isAxiosError(error)) {
    const status = error.response?.status;
    if (status === 401) return "Your mytender session has expired. Sign out and back in.";
    if (status === 403) return "You don't have access to this tender in mytender.";
    if (status === 404) return "This mytender server doesn't have Word sync yet.";
    if (status && status >= 500) return `mytender had a problem answering (error ${status}). Try again in a moment.`;
    if (status) return `mytender returned an error (${status}).`;
    return "Can't reach mytender. Check your connection.";
  }
  return error instanceof Error && error.message ? error.message : "Can't reach mytender.";
};
